/**
 *  @class
 *  @function Pagination
 */

if (!customElements.get("pagination")) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      this.button = this.querySelector(".load-more");
      this.grid = document.querySelector("[data-id=" + id + "]");
      this.animations_enabled =
        document.body.classList.contains("animations-true") &&
        typeof gsap !== "undefined";
      this.i = 2;
      this.page_size = this.dataset.pageSize;
      this.is_intersecting = false;
    }
    connectedCallback() {
      if (this.classList.contains("pagination-type--loadmore")) {
        this.loadMore();
      }
      if (this.classList.contains("pagination-type--infinite")) {
        this.infinite();
      }
    }
    addUrlParam(search, key) {
      var newParam = key + "=" + this.i,
        params = "?" + newParam;

      // If the "search" string exists, then build params from it
      if (search) {
        // Try to replace an existance instance
        params = search.replace(
          new RegExp("([?&])" + key + "[^&]*"),
          "$1" + newParam
        );

        // If nothing was replaced, then add the new param to the end
        if (params === search) {
          params += "&" + newParam;
        }
      }

      return params;
    }
    loadMore() {
      let base = this;
      this.button.addEventListener("click", function () {
        base.loadProducts();
        this.blur();
        return false;
      });
    }
    infinite() {
      let base = this;
      // ESKI KOD: Sadece eleman tamamen görünürse tetikleniyordu.
      // Hızlı scroll'da eleman viewport'a tam girmeden "atlanınca"
      // loadProducts çalışmıyor ve sonsuz yükleme hissi oluşuyordu.
      // base.observer = new IntersectionObserver(function (entries) {
      //   if (entries[0].intersectionRatio === 1) {
      //     base.loadProducts();
      //   }
      // }, {
      //   threshold: [0, 1]
      // });

      // YENI KOD: Eleman görünür görünmez (tam görünmesi şart değil)
      // tetikler. rootMargin ile biraz önce yükleme yaparak hızlı scroll'da
      // kaçırmayı engeller.
      base.observer = new IntersectionObserver(
        function (entries) {
          base.is_intersecting = entries[0].isIntersecting;
          if (base.is_intersecting && !base.getAttribute("loading")) {
            base.loadProducts();
          }
        },
        {
          threshold: 0,
          rootMargin: "0px 0px 300px 0px",
        }
      );
      base.observer.observe(base);
    }
    loadProducts() {
      let base = this,
        url =
          document.location.pathname +
          base.addUrlParam(document.location.search, "page");
      if (base.getAttribute("loading")) {
        return;
      }
      base.i++;
      base.setAttribute("loading", true);
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = responseText;
          base.renderProducts(html, url);

          dispatchCustomEvent("pagination:page-changed", {
            url: url,
          });
        })
        .catch(() => {
          // Hata olursa yükleme kilidini kaldır, kullanıcı scroll ile tekrar deneyebilsin.
          base.removeAttribute("loading");
        });
    }
    renderProducts(html, url) {
      let base = this,
        grid_to_replace = new DOMParser()
          .parseFromString(html, "text/html")
          .getElementById("product-grid");

      if (!grid_to_replace) {
        if (base.observer) {
          base.observer.unobserve(base);
        }
        base.removeAttribute("loading");
        if (base.button) {
          base.button.classList.add("visually-hidden");
        }
        return;
      }
      let products = grid_to_replace.querySelectorAll(".column");

      for (var i = 0; i < products.length; i++) {
        this.grid.appendChild(products[i]);
        products[i].querySelectorAll(".lazyload").forEach((image) => {
          lazySizes.loader.unveil(image);
        });
      }
      if (this.animations_enabled) {
        gsap.set(products, {
          opacity: 0,
          y: 30,
        });
        gsap.to(products, {
          duration: 0.5,
          y: 0,
          opacity: 1,
          stagger: 0.05,
          onComplete: function () {
            base.removeAttribute("loading");
            // Sentinel hâlâ görünüyorsa bir sonraki sayfayı tetiklemek için
            // tekrar kontrol et (observer aynı durumda yeniden tetiklemeyebilir).
            if (base.is_intersecting && products.length >= base.page_size) {
              requestAnimationFrame(() => base.loadProducts());
            }
          },
        });
      } else {
        base.removeAttribute("loading");
        if (typeof StampedFn.loadBadges !== "undefined") {
          StampedFn.loadBadges();
        }
        if (base.is_intersecting && products.length >= base.page_size) {
          requestAnimationFrame(() => base.loadProducts());
        }
      }
      if (products.length < this.page_size) {
        this.hide();
      }
    }
    hide() {
      if (this.observer) {
        this.observer.unobserve(this);
      }
      this.button.style.display = "none";
    }
  }
  customElements.define("pagination-theme", Pagination);
}
